package org.catharsis.spendtel.feature.presentation.expensereport

import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import org.catharsis.TVTally.theme.deepGreen
import org.catharsis.TVTally.theme.navy

object SpendTelReportColors {
    val canvas = Color(0xFFFAF7F2)
    val canvasDark = Color(0xFFF3EEE6)
    val ink = navy
    val inkMuted = Color(0xFF5C6B82)

    val coral = Color(0xFFFF6B6B)
    val amber = Color(0xFFFFB347)
    val violet = Color(0xFF7C5CFC)
    val indigo = Color(0xFF5B8DEF)
    val teal = Color(0xFF2EC4B6)
    val rose = Color(0xFFFF8FAB)
    val sage = Color(0xFF52B788)
    val sky = Color(0xFF4CC9F0)
    val plum = Color(0xFF9B5DE5)
    val mint = deepGreen

    val increase = Color(0xFFE85D4C)
    val decrease = sage

    val sectionAccents = listOf(coral, violet, teal, amber, rose, indigo, plum, sky, mint)
}

object SpendTelGradients {
    val hero = Brush.linearGradient(
        colors = listOf(
            Color(0xFF1B2A4A),
            Color(0xFF2D4A7A),
            Color(0xFF009975),
        ),
    )

    val personality = Brush.linearGradient(
        colors = listOf(
            Color(0xFF6D4CFF),
            Color(0xFF5B8DEF),
            Color(0xFF2EC4B6),
        ),
    )

    val storyWarm = Brush.linearGradient(
        colors = listOf(
            Color(0xFFFF8A65),
            Color(0xFFFFB347),
        ),
    )

    val evolution = Brush.linearGradient(
        colors = listOf(
            Color(0xFF52B788),
            Color(0xFF2EC4B6),
        ),
    )

    val insight = Brush.linearGradient(
        colors = listOf(
            Color(0xFFFF8FAB),
            Color(0xFF9B5DE5),
        ),
    )

    val merchant = Brush.linearGradient(
        colors = listOf(
            Color(0xFF4CC9F0),
            Color(0xFF5B8DEF),
        ),
    )

    private val wrappedCards = listOf(
        Brush.linearGradient(
            colors = listOf(Color(0xFF6D4CFF), Color(0xFFE040FB), Color(0xFFFF6B6B)),
        ),
        Brush.linearGradient(
            colors = listOf(Color(0xFF009975), Color(0xFF2EC4B6), Color(0xFF4CC9F0)),
        ),
        Brush.linearGradient(
            colors = listOf(Color(0xFFFF8A65), Color(0xFFFFB347), Color(0xFFFF5E78)),
        ),
        Brush.linearGradient(
            colors = listOf(Color(0xFF1B2A4A), Color(0xFF5B8DEF), Color(0xFF9B5DE5)),
        ),
        Brush.linearGradient(
            colors = listOf(Color(0xFFFF8FAB), Color(0xFF9B5DE5), Color(0xFF7C5CFC)),
        ),
    )

    fun wrappedForIndex(index: Int): Brush {
        return wrappedCards[index.absoluteMod(wrappedCards.size)]
    }
}

private val Int.absoluteValue: Int
    get() = if (this < 0) -this else this

private fun Int.absoluteMod(modulus: Int): Int {
    val remainder = this % modulus
    return if (remainder < 0) remainder + modulus else remainder
}

fun accentForIndex(index: Int): Color {
    return SpendTelReportColors.sectionAccents[index.absoluteMod(SpendTelReportColors.sectionAccents.size)]
}

fun accentForLabel(label: String): Color {
    return SpendTelReportColors.sectionAccents[label.hashCode().absoluteMod(SpendTelReportColors.sectionAccents.size)]
}
